var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CallbackQueue_1;
import { injectable } from '../../decorators/injectable';
/** The name of the module */
export const name = 'CallbackQueue';
let CallbackQueue = CallbackQueue_1 = class CallbackQueue {
    constructor() {
        /** The map of callback sets */
        this.queue = new Map();
    }
    /**
       * Add a callback function to a keyed set
       *
       * @param queueName The queue (generally the name of the module calling this function) being accessed
       * @param queueKey The key to the callback set to add to
       * @param callback The callback function to add
       */
    add(queueName, queueKey, callback) {
        const key = CallbackQueue_1.buildKey(queueName, queueKey);
        // Create the set if it doesn't already exist
        if (!this.queue.has(key)) {
            this.queue.set(key, new Set());
        }
        // Add the callback to the set
        this.queue.get(key).add(callback);
    }
    /**
       * Remove a callback function from a keyed set
       *
       * @param queueName The queue (generally the name of the module calling this function) being accessed
       * @param queueKey The key to the callback set to remove from
       * @param callback The callback function to remove
       */
    remove(queueName, queueKey, callback) {
        const key = CallbackQueue_1.buildKey(queueName, queueKey);
        // Remove the callback from the set if it exists
        if (this.queue.has(key)) {
            return this.queue.get(key).delete(callback);
        }
        return false;
    }
    /**
       * Iterate through and execute all callbacks for a set
       *
       * @param queueName The queue (generally the name of the module calling this function) being accessed
       * @param queueKey The key to the callback set to execute
       * @param thisArg Optional 'this' context to apply to function
       */
    async fire(queueName, queueKey, thisArg) {
        const key = CallbackQueue_1.buildKey(queueName, queueKey);
        // Make sure the set exists
        if (this.queue.has(key)) {
            // Loop through each callback in the set
            this.queue.get(key).forEach(async (callback) => {
                // Currying to remove arguments and bind context
                await callback.call(thisArg);
            });
        }
    }
    /**
       * Build a paired name/key string to be used as the main key for storage and lookup
       *
       * @param queueName Name of the queue (generally the module name)
       * @param queueKey Key for this queue belonging to the above-named module
       */
    static buildKey(queueName, queueKey) {
        return `${queueName}:${queueKey}`;
    }
};
CallbackQueue = CallbackQueue_1 = __decorate([
    injectable(name)
], CallbackQueue);
export default CallbackQueue;
